<template>
<div class="row g-0">
	<div
		v-for="station in filteredStations"
		:key="station.id"
		class="col col-lg-6 col-xl-4 col-xxl-3 p-1 m-0"
	>
		<router-link
			class="text-start text-break text-reset text-decoration-none"
			:to="{ name: 'station_control', params: { id: `${station.id}` } }"
		>
			<one-station-tile 
				:station="station"
			/>
		</router-link>
	</div>
</div>
</template>




<script>
import OneStationTile from './OneStationTile.vue'
import { useStationsStore } from '@/stores/StationsStore'
import { useSessionStore } from '@/stores/SessionStore'
import { Station } from '@/models/station'
import { EMPTY_COLUMN_VALUE } from '@/app.conf'


export default {
	components: {
		OneStationTile,
	},

	props: {
		nameFilter: {
			type: String,
			required: false,
			default: '',
		}
	},

	setup() {
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()
		
		return {
			stationsStore,
			sessionStore,
			Station,
		}
	},

	methods: {},

	computed: {
		filteredStations() {
			const replaceEmptyColumnValue = (value) => {
				if (value === undefined || String(value) === EMPTY_COLUMN_VALUE) {
					return "-"
				} else {
					return value
				}
			}

			let allStations = this.stationsStore.stationsArray
			const filteredStationsName = this.sessionStore.getFilter(this.$route.name, 'organization')
			const filteredDepartments = this.sessionStore.getFilter(this.$route.name, 'department')
			const filteredSectors = this.sessionStore.getFilter(this.$route.name, 'sector')
			const filteredActivity = this.sessionStore.getFilter(this.$route.name, 'activity')
			const filteredProtection = this.sessionStore.getFilter(this.$route.name, 'protection')
			const filteredMode = this.sessionStore.getFilter(this.$route.name, 'mode')

			allStations = allStations
				// Apply filters
				.filter((station) => 
					filteredStationsName.includes(station.passport.get(Station.passportKeys.orgName))
				).filter((station) => 
					filteredDepartments.includes(replaceEmptyColumnValue(station.passport.get(Station.passportKeys.department)?.title))
				).filter((station) => 
					filteredSectors.includes(replaceEmptyColumnValue(station.passport.get(Station.passportKeys.sector)?.title))
				).filter((station) => 
					filteredActivity.includes(station.isActive ? "так" : "ні")
				).filter((station) => 
					filteredProtection.includes(station.protectionText)
				).filter((station) => 
					filteredMode.includes(station.power_unit.stabilizationModeText)
				// Sort by name acs (like table view)
				).sort((a, b) => (a.shortName ? a.shortName : a.name) > (b.shortName ? b.shortName : b.name))

			// Filter by name
			const search = this.nameFilter.trim()
			// If search phrase is empty
			if (search === '') {
				return allStations
			// If search phrase is one word
			} else if (search.indexOf(' ') == -1) {
				// Filter items where any word starts with search phrase
				return allStations.filter((el) => {
					const stationNameKey = el.passport.has(Station.passportKeys.shortName)
						? Station.passportKeys.shortName
						: Station.passportKeys.name
					
					// Split string to words
					const words = el.passport.get(stationNameKey).toLowerCase().split(/\s+/)

					// Check awery word
					return words.some((word) => 
						word.startsWith(search.toLowerCase())
					)
				})
			} else {
				return allStations.filter((el) => el[Station.passportKeys.name].toLowerCase().includes(search.toLowerCase()))
			}

			// return allStations
		},
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style scoped>
</style>